import { Col, Form, Row, Select, Skeleton } from "antd"
import React, { useCallback, useEffect, useState } from "react"

import { TimezoneSelect } from "../../../../../components/Shared/TimezoneSelect.tsx"
import { useAppDispatch } from "../../../../../hooks/use-app-dispatch.ts"
import { fetchTeamMembersFilterOptions } from "../../../../TeamManagementPage/redux/team-members.thunks.ts"
import { type TeamMembersFilterOptions } from "../../../../TeamManagementPage/redux/team-members.types.ts"

export function AccountTimeSection() {
  const dispatch = useAppDispatch()
  const [options, setOptions] = useState<TeamMembersFilterOptions | null>(null)
  const [loading, setLoading] = useState(true)

  const handleGetFilterOptions = useCallback(async () => {
    try {
      setLoading(true)
      const res = await dispatch(fetchTeamMembersFilterOptions()).unwrap()
      if (res) setOptions(res)
    } finally {
      setLoading(false)
    }
  }, [dispatch])

  useEffect(() => {
    void handleGetFilterOptions()
  }, [handleGetFilterOptions])

  return (
    <>
      <Form.Item
        label={"Time Zone"}
        name={"timezone"}
        rules={[{ required: true, message: "Please select a timezone" }]}
      >
        {loading ? (
          <Skeleton.Input className={"w-full"} />
        ) : (
          <TimezoneSelect showSearch optionFilterProp={"searchText"} />
        )}
      </Form.Item>

      {/*<Row>*/}
      {/*<Col span={17}>*/}
      <Form.Item
        label={"Date Format"}
        name={"date_format"}
        rules={[{ required: true, message: "Please select a date format" }]}
      >
        {loading ? (
          <Skeleton.Input className={"w-full"} />
        ) : (
          <Select
            options={options?.date_format || []}
            placeholder="Select date format"
          />
        )}
      </Form.Item>
      {/*</Col>*/}

      {/*<Col span={7}>*/}
      {/*  <Form.Item*/}
      {/*    label={"Time Format"}*/}
      {/*    name={"time_format"}*/}
      {/*    rules={[{ required: true, message: "Please select a timezone" }]}*/}
      {/*  >*/}
      {/*    {loading ? (*/}
      {/*      <Skeleton.Input className={"w-full"} />*/}
      {/*    ) : (*/}
      {/*      <Select*/}
      {/*        disabled*/}
      {/*        options={options?.time_format || []}*/}
      {/*        placeholder="Select time format"*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  </Form.Item>*/}
      {/*</Col>*/}
      {/*</Row>*/}
    </>
  )
}
